import { Injectable } from "@angular/core";
import { Storage } from "@ionic/storage-angular";
import { ArrayStorageRepository } from "./abstract/array.storage.repository";
import { ImageFile } from "../types/Image/ImageFile";

export interface ClientImagesRecord {
  dlClientID: string;
  images: ImageFile[];
}

@Injectable({
  providedIn: "root",
})
export class ClientImagesRepository extends ArrayStorageRepository<ClientImagesRecord> {
  constructor(storage: Storage) {
    super(storage, "clientImages", "dlClientID");
  }

  public setClientImages(
    dlClientID: string,
    images: ImageFile[],
  ): Promise<ClientImagesRecord> {
    return this.saveRecord("dlClientID", { dlClientID, images });
  }

  public async getClientImages(dlClientID: string): Promise<ImageFile[]> {
    const record = await this.getById(dlClientID);
    return record?.images || [];
  }
}
